import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { SearchDialogComponent, DialogData } from './search-dialog.component';
import { ProfileService } from '../profile/profile.service';
import { ProfileModelService } from '../profile/profile-model.service';

@Injectable()
export abstract class BaseSearchDialogComponent {

    constructor(
        public dialog: MatDialog,
        public profileService: ProfileService,
        public profileModelService: ProfileModelService) {
    }
    openDialog(isHomePage: boolean): void {
        const dialogRef = this.dialog.open(SearchDialogComponent, this.getDialogConfig(this, isHomePage));
        dialogRef.afterClosed().subscribe(dialogData => {
            this.saveDialogData(dialogData);
        });
    }

    saveDialogData(dialogData: DialogData, type?: any): void {
        if (dialogData) {
            if (!dialogData.isDelete) {
                this.dialogUpdate(dialogData, type);
            }
            this.profileService.updateConfiguration(this.profileModelService.configuration).subscribe(
                (profile) => {
                    this.profileModelService.profile = profile;
                    this.afterSavedDialog(dialogData.filterName, type);
                }
            );
            if(dialogData.isDelete) {
                this.clearFilters();
            }
        }
    }

    openEditDialogFilter(configData: any, type?: any) {
        const dialogConfig: MatDialogConfig = this.getDialogConfig(configData);
        const dialogRef = this.dialog.open(SearchDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((dialogData: DialogData) => {
            this.saveDialogData(dialogData, type);
        });
        return dialogRef;
    }

    getDialogConfig(configData: any, isHomePage: boolean = true): MatDialogConfig {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '938px';
        if (!configData.hasOwnProperty('isHomePage')) {
            configData.isHomePage = isHomePage;
        }
        dialogConfig.data = configData;
        dialogConfig.hasBackdrop = true;
        return dialogConfig;
    }

    abstract dialogUpdate(dialogData: DialogData, type?: any): void;

    abstract afterSavedDialog(filterName: string, type?: any): void;

    abstract clearFilters(event?: any): void;
}
